export const cities = [
  "Delhi",
  "New Delhi",
  "Noida",
  "Greater Noida",
  "Ghaziabad",
  "Gurugram",
  "Faridabad",
  "Bangalore",
  "Barabanki",
  "Bareilly",
  "Bhubaneswar",
  "Chandigarh",
  "Dehradun",
  "Gwalior",
  "Jaipur",
  "Kathmandu-Nepal",
  "Lucknow",
  "Meerut",
  "Mohali",
  "Pathankot",
  "Zirakpur",
];

import avatarIImg from "../../assets/expert.png";
import avatarIIImg from "../../assets/profile.jpeg";
import avatarIIIImg from "../../assets/profile.jpeg";
import avatarIVImg from "../../assets/profile.jpeg";
import avatarVImg from "../../assets/profile.jpeg";

export const testimonials = [
  {
    img: avatarIImg,
    text: "SalonTym gave me the financial stability I always wanted, and I now have the respect of my family and clients.",
    author: "Dolly Kour, Delhi",
  },
  {
    img: avatarIIImg,
    text: "Thanks to SalonTym, I can balance my career and personal life. My family and husband respect my decision to pursue this.",
    author: "Reena, Noida",
  },
  {
    img: avatarIIIImg,
    text: "SalonTym elevated my career and earned me respect from both clients and family. It’s been a great journey.",
    author: "Manju, Chandigarh",
  },
  {
    img: avatarIVImg,
    text: "Working with SalonTym has been rewarding. I’ve gained professional growth and the admiration of my family.",
    author: "Rekha, Gurgaon",
  },
  {
    img: avatarVImg,
    text: "SalonTym empowered me to take control of my career, and it’s brought respect and pride from my family.",
    author: "Heena, Lucknow",
  },
];

export const hindiTestimonials = [
  {
    img: avatarIImg,
    text: "SalonTym ने मुझे वह वित्तीय स्थिरता दी, जिसकी मैं हमेशा चाहती थी, और अब मेरे परिवार और क्लाइंट्स का सम्मान भी मुझे मिला है।",
    author: "डॉली कौर, दिल्ली",
  },
  {
    img: avatarIIImg,
    text: "SalonTym के कारण, मैं अपने करियर और व्यक्तिगत जीवन का संतुलन बना सकती हूँ। मेरे परिवार और पति मेरे इस फैसले का सम्मान करते हैं।",
    author: "रीना, नोएडा",
  },
  {
    img: avatarIIIImg,
    text: "SalonTym ने मेरे करियर को ऊंचाइयों तक पहुँचाया और मुझे परिवार और क्लाइंट्स का सम्मान दिलवाया। यह एक शानदार यात्रा रही है।",
    author: "मंजू, चंडीगढ़",
  },
  {
    img: avatarIVImg,
    text: "SalonTym के साथ काम करना फायदेमंद रहा है। मैंने पेशेवर रूप से विकास किया और मेरे परिवार का सम्मान भी प्राप्त किया।",
    author: "रेखा, गुड़गांव",
  },
  {
    img: avatarVImg,
    text: "SalonTym ने मुझे मेरे करियर को नियंत्रित करने की शक्ति दी, और इससे मुझे मेरे परिवार का सम्मान और गर्व मिला।",
    author: "हीना, लखनऊ",
  },
];

export const points = [
  {
    title: "Master Your Craft:",
    description:
      "SalonTym equips you with the knowledge and training to become a skilled professional in the beauty and wellness industry. Start earning from the very beginning while gaining hands-on experience and staying informed about the latest industry advancements.",
  },
  {
    title: "Flexible Work Options:",
    description:
      "At SalonTym, you have the freedom to choose your preferred working hours and areas, ensuring a perfect work-life balance. Our Partner App provides easy access to all job-related details, making your experience seamless and efficient.",
  },
  {
    title: "Upgrade Your Skills:",
    description:
      "We offer a diverse range of beauty and wellness services, including Female Spa, Female Grooming, Female Massage, Korean Facial, and Hair Services. Select the services you want to specialize in, undergo expert training, and refine your skills.",
  },
  {
    title: "Unlock Earning Potential:",
    description:
      "The growing demand for beauty and wellness professionals ensures significant earning opportunities. At SalonTym, your income potential knows no bounds. The more you work, the more you earn, empowering you to achieve your financial goals.",
  },
];

export const hindiPoints = [
  {
    title: "अपने कौशल में महारत हासिल करें:",
    description:
      "SalonTym आपको ब्यूटी और वेलनेस उद्योग में एक कुशल पेशेवर बनने के लिए आवश्यक ज्ञान और प्रशिक्षण प्रदान करता है। शुरुआत से ही कमाई शुरू करें, जबकि आप हाथों-हाथ अनुभव प्राप्त करते हैं और नवीनतम उद्योग विकास के बारे में सूचित रहते हैं।",
  },
  {
    title: "लचीले काम के विकल्प:",
    description:
      "SalonTym में, आपके पास अपने पसंदीदा कार्य घंटों और क्षेत्रों को चुनने की स्वतंत्रता है, जिससे एक सही कार्य-जीवन संतुलन सुनिश्चित होता है। हमारा पार्टनर ऐप सभी नौकरी संबंधित विवरणों तक आसान पहुंच प्रदान करता है, जिससे आपका अनुभव सहज और प्रभावी होता है।",
  },
  {
    title: "अपने कौशल को उन्नत करें:",
    description:
      "हम ब्यूटी और वेलनेस सेवाओं की एक विस्तृत श्रृंखला प्रदान करते हैं, जिसमें महिला स्पा, महिला ग्रूमिंग, महिला मसाज, कोरियाई फेशियल, और हेयर सर्विसेज शामिल हैं। उन सेवाओं का चयन करें जिनमें आप विशेषज्ञता प्राप्त करना चाहते हैं, विशेषज्ञ प्रशिक्षण प्राप्त करें और अपने कौशल को परिष्कृत करें।",
  },
  {
    title: "कमाई की संभावनाओं को अनलॉक करें:",
    description:
      "ब्यूटी और वेलनेस पेशेवरों की बढ़ती मांग महत्वपूर्ण कमाई के अवसर सुनिश्चित करती है। SalonTym में, आपकी आय की संभावनाएं असीमित हैं। जितना अधिक आप काम करेंगे, उतना अधिक आप कमाएंगे, जो आपको अपने वित्तीय लक्ष्यों को प्राप्त करने के लिए सशक्त बनाता है।",
  },
];
